import { CertificateAttribute } from 'src/types/TaxExemptionCertificate';
import { SortOrder } from 'src/components/Table/SortableColumn';

export type SortConfig = {
  sortField: CertificateAttribute;
  sortOrder: SortOrder;
  previousSortField?: CertificateAttribute;
  previousSortOrder?: SortOrder;
};

export const defaultSortConfig: SortConfig = {
  sortField: CertificateAttribute.state,
  sortOrder: SortOrder.ASC,
  previousSortField: CertificateAttribute.state,
  previousSortOrder: SortOrder.ASC,
};
